import type { XY } from "../xy";
import { XYEffect } from "./xyEffect";

export class FadeIn extends XYEffect {
	static key = "FadeIn";
	private timer: number;

	constructor(xy: XY, timer: number) {
		super(xy);
		this.timer = timer;
	}

	getTimer(): number {
		return this.timer;
	}
}
